// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';
// Utils
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const FINANCIAL_DATA_TOOLTIP_ASSET_CONSTANTS = {
    dataTestId: 'financial-data-tooltip-info',
    icon: 'icon_symbols_information-in-a-circle',
    width: convertPxsToRems({ pixels: 24 }),
    height: convertPxsToRems({ pixels: 24 }),
  },
  FINANCIAL_DATA_TOOLTIP_CONSTANTS = {
    align: VARIANTS.TooltipVariantType.TOP,
    contentScrollArias: {
      'aria-label': 'Tooltip content scroll',
    },
    tooltipAsModal: false,
    triggerAsButton: {
      'aria-label': 'Tooltip trigger',
    },
    variant: 'REGULAR',
  };

export { FINANCIAL_DATA_TOOLTIP_ASSET_CONSTANTS, FINANCIAL_DATA_TOOLTIP_CONSTANTS };
